import { observable } from "mobx";
import { fetchCertInfo, fetchCertCheckUrl } from '@/services/cert';

// 证件审核信息
const cert = observable({
  certNo: '',
  certName: '',
  isOverdue: true, // 是否过期
  certStartDate: '',
  certEndDate: '',
  url: '', // 上传证件链接
  // 获取证件审核链接
  async getCertCheckUrl(payload) {
    const res = await fetchCertCheckUrl(payload);
    this.url = res?.url || '';
    return res;
  },
  // 获取证件审核信息
  async getCertInfo(payload) {
    const res = await fetchCertInfo(payload) || {};
    this.certNo = res.certNo;
    this.certName = res.certName;
    this.isOverdue = res.isOverdue;
    this.certStartDate = res.certStartDate;
    this.certEndDate = res.certEndDate;
  },
  // 清空证件审核信息
  async clearCertInfo() {
    this.certNo = undefined;
    this.certName = undefined;
    this.isOverdue = undefined;
    this.certStartDate = undefined;
    this.certEndDate = undefined;
  },
});

export default cert;
